<template>
<div
  class="table-container"
  :class="isMobile && tableData ? 'fixed-height' : ''"
  :style="cssVarDemo">
  <canvas
    ref="tableCanvas"
    style="position:absolute;top:0;left:0;z-index:99;"
    :width="canvasW"
    :height="canvasH">
  </canvas>
  <!-- responsive -->
  <b-table-simple>
    <colgroup><col></colgroup>
    <colgroup><col></colgroup>
    <colgroup
      v-for="(head, idx) in headArr"
      :key="'set-col-' + idx">
      <col
        v-for="(subHead, subIdx) in subHeadSet"
        :key="'set-sub-col-' + idx + subIdx">
    </colgroup>
    <b-thead>
      <b-tr>
        <b-th
          rowspan="2">开奖期数</b-th>
        <b-th
          rowspan="2">开奖号码</b-th>
        <b-th
          v-for="(head, idx) in headArr"
          :key="'head-col' + idx"
          :colspan="subHeadSet.length"
          >
          {{ head }}
        </b-th>
      </b-tr>
      <b-tr>
        <b-th
          v-for="(subHead, idx) in subHeadArr"
          :key="'head-sub-col-' + idx">
          {{ subHead }}
        </b-th>
      </b-tr>
    </b-thead>
    <b-tbody ref="tableBody">
      <b-tr v-if="!tableData">
        <b-td
          :colspan="tableColNum"
          :class="showMsg == 'error' ? 'error-msg' : ''">
          {{tableMsg[showMsg]}}
        </b-td>
      </b-tr>
      <b-tr
        v-else
        v-for="(lot, idx) in tableData"
        :key="lot.id">
        <!-- 开奖期数 -->
        <b-td>{{ lot.issue }}</b-td>
        <!-- 开奖号码 -->
        <b-td>
          <div class="result-nums-container">
            <div
              v-for="(num, numIdx) in generateLotNums(lot.code)"
              :key="'lot-num-' + lot.id + numIdx">
              <!-- {{ generateResultNum(num) }} -->
              {{ num }}
              </div>
          </div>
        </b-td>
        <!-- 位數號碼 -->
        <b-td
          v-for="(subNum, subIdx) in subHeadArr"
          :key="'row-' + lot.id + '-idx-' + subIdx"
          :class="generateCellClass(lot, idx, subIdx)">
          <!-- v-if="showCellContent(subIdx, lot)" -->
          <div
            class="num-container"
            :class="generateLotNumClass(subIdx, lot)">
            {{ generateCellContent(lot, idx, subIdx) }}
          </div>
          <!-- <div
            v-else
            class="num-container not-lot-num" /> -->
        </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</div>
</template>

<script>
import { concat, range, findIndex } from 'lodash'
import { getLotWinNumHistory } from '@/api/client/lot'
import resStatus from '@/constants/resStatus'
import { fillDigit } from '@/utils/string'
import { getLotInfoById } from '@/utils/lot'
import { isMobile } from '@/utils/device'

export default {
  props: {
    updateStatus: {
      type: Boolean,
      required: true
    },
    headArr: {
      type: Array,
      required: true
    },
    resultMinNum: {
      type: Number,
      required: true
    },
    resultMaxNum: {
      type: Number,
      required: true
    },
    leaksStatus: {
      type: Boolean,
      required: true
    },
    leaksLevelStatus: {
      type: Boolean,
      required: true
    },
    showLineStatus: {
      type: Boolean,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      // headArr: ['万位', '千位', '百位', '十位', '个位'],
      // resultMinNum: 0,
      // resultMaxNum: 9,
      firstLoaded: true,
      tableData: null,
      cssVarDemo: {
        '--col-min-width': '500px'
      },
      canvasW: 0,
      canvasH: 0,
      showMsg: '',
      tableMsg: {
        error: '發生错误，请稍后再试',
        empty: '目前尚无资料',
        loading: '获取资料中...'
      }
    }
  },
  computed: {
    lotId: {
      get () {
        return this.$route.query.id
      }
    },
    lotInfo: {
      get () {
        return getLotInfoById(this.lotId)
      }
    },
    subHeadArr: {
      get () {
        let retArr = []
        range(this.headArr.length).forEach(() => {
          retArr = concat(retArr, this.subHeadSet)
        })
        return retArr
      }
    },
    subHeadSet: {
      get () {
        return range(this.resultMinNum, this.resultMaxNum + 1)
      }
    },
    tableColNum: {
      get () {
        return (this.subSetLen * this.headArr.length) + 2
      }
    },
    subSetLen: {
      get () {
        return this.subHeadSet.length
      }
    },
    query: {
      get () {
        return {
          // page: 1,
          // pageSize: this.pageSize,
          // date: "2021-04-01",
          code: this.lotId,
          latest: this.pageSize
        }
      }
    },
    isMobile () {
      return isMobile()
    }
  },
  methods: {
    initTableData () {
      // this.emptyPageData()
      this.showMsg = 'loading'
      getLotWinNumHistory(this.query)
        .then(res => {
          if (res.status === resStatus.OK) {
            if (res.data.length === 0) {
              this.showMsg = 'empty'
              this.emptyPageData ()
            } else {
              this.tableData = res.data
              this.showMsg = ''
            }
          } else {
            this.showMsg = 'error'
            this.emptyPageData ()
          }
        })
    },
    emptyPageData () {
      this.tableData = null
      this.canvasW = 0
      this.canvasH = 0
    },
    generateLotNums (numStr) {
      return numStr.split(',')
    },
    generateResultNum (num) {
      if (this.lotInfo.rule.chart.resultFillZero) {
        return fillDigit(num, 2, '0')
      }
      return num
    },
    generateCellContent (lot, idx, subIdx) {
      const setGroup = this.getSubSetGroup(subIdx)
      const lotCodes = this.getLotCodes(lot)
      if (this.showLotNum(subIdx, lot)) {
        if (this.lotInfo.rule.chart.resultFillZero) {
          return fillDigit(lotCodes[setGroup], 2, '0')
        }
        return lotCodes[setGroup]
      } else {
        if (this.showCellContent(subIdx, lot)) {
          return this.getLeaksNum(idx, subIdx)
        }
        return ''
      }
    },
    getSubSetGroup (subIdx) {
      return Math.floor(subIdx / this.subSetLen)
    },
    getLotCodes (lot) {
      return lot.code.split(',')
    },
    showLotNum (subIdx, lot) {
      const setGroup = this.getSubSetGroup(subIdx)
      const lotCodes = this.getLotCodes(lot)
      return (subIdx + this.resultMinNum) === setGroup * this.subSetLen + Number(lotCodes[setGroup])
    },
    getLeaksNum (idx, subIdx) {
      if (!this.tableData) {
        return ''
      }
      const groupNextNumIdx = this.getGroupNextNumIdx(idx, subIdx)
      return groupNextNumIdx - idx
    },
    getGroupNextNumIdx (idx, subIdx) {
      const setGroup = this.getSubSetGroup(subIdx)
      const subIdxNum = subIdx % this.subSetLen + this.resultMinNum
      const nextIdx = findIndex(this.tableData, (i) => {
        return Number(i.code.split(',')[setGroup]) === subIdxNum
      }, idx)
      if (nextIdx === -1) {
        // return this.query.latest
        return this.tableData.length
      }
      return nextIdx
    },
    showCellContent (subIdx, lot) {
      if (this.showLotNum(subIdx, lot)) {
        return true
      }
      return this.leaksStatus
    },
    generateLotNumClass (subIdx, lot) {
      if (this.showLotNum(subIdx, lot)) {
        return `lot-num lot-num-col-${this.getLotCol(subIdx)}`
      }
      return 'not-lot-num'
    },
    getLotCol (subIdx) {
      return Math.floor(subIdx / (this.resultMaxNum - this.resultMinNum + 1))
    },
    generateCellClass (lot, idx, subIdx) {
      const cellClass = `digit-default digit-${this.getSubSetGroup(subIdx)}`
      const groupNextNumIdx = this.getGroupNextNumIdx(0, subIdx)
      if (
        !this.showLotNum(subIdx, lot) &&
        this.leaksLevelStatus &&
        groupNextNumIdx - idx > 0
      ) {
        return `${cellClass} leaksLevel`
      }
      return `${cellClass} leaksLevel-no`
    },
    handleDrawLine () {
      setTimeout(() => {
        const tbody = this.$refs.tableBody.$el
        if (
          tbody &&
          this.tableData &&
          this.tableData.length !== 0
        ) {
          this.lotTd = tbody.firstChild.children[2]
          this.canvasW = tbody.offsetWidth
          this.canvasH = tbody.offsetHeight + (this.lotTd.offsetHeight * 2)
          // wait for component mounted
          setTimeout(() => {
            this.canvasDraw = this.$refs.tableCanvas.getContext('2d')
            this.clearCanvas()
            this.canvasDraw.strokeStyle = '#3cb0ec'
            this.drawBallLine()
          }, 10)
        }
      }, 10)
    },
    clearCanvas () {
      const canvas = this.$refs.tableCanvas
      this.canvasDraw.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight)
    },
    drawBallLine () {
      if (this.showLineStatus) {
        for (let i = 0, c = this.headArr.length; i < c; i++) {
          for (let j = 0, d = this.tableData.length - 1; j < d; j++) {
            const start = this.getBallPosition(i, j)
            const end = this.getBallPosition(i, j + 1)
            this.drawOneLine(start, end)
          }
        }
      }
    },
    getBallPosition (ballCol, ballIdx) {
      const ball = this.$refs.tableBody.$el.querySelectorAll(`.lot-num-col-${ballCol}`)[ballIdx]
      return {
        x: ball.parentElement.offsetLeft + (this.lotTd.offsetWidth / 2),
        y: ball.parentElement.offsetTop + (this.lotTd.offsetHeight / 2)
      }
    },
    drawOneLine (start, end) {
      // console.log('draw one line: ', start, end)
      const c = this.canvasDraw
      c.beginPath()
      c.moveTo(start.x, start.y)
      c.lineTo(end.x, end.y)
      c.stroke()
    }
  },
  created () {
    this.initTableData()
  },
  watch: {
    // query (val) {
    //   this.initTableData()
    // },
    updateStatus (val) {
      if (this.firstLoaded) {
        this.firstLoaded = false
      } else if (val) {
        this.initTableData()
      }
    },
    tableData (val) {
      if (val) {
        this.handleDrawLine()
      }
    },
    showLineStatus (val) {
      this.handleDrawLine()
    },
    pageSize (val) {
      this.initTableData()
    }
  }
}
</script>

<style lang="scss" scoped>
$bg-orange: #fbf6f0;
$bg-blue: #edf8fc;
$bg-green: #ecfcec;
$bg-purple: #ededfc;
$bg-emerald: #edfcf6;
$bg-yellow: #fcfced;
$bg-red: #fceded;
$bg-cyan: #edf2fc;
$bg-default: #edf2fc;

$circle-orange: #ee954b;
$circle-blue: #3594e3;
$circle-green: #55b810;
$circle-purple: #716cfa;
$circle-emerald: #4fb383;
$circle-yellow: #bed458;
$circle-red: #ce38bb;
$circle-cyan: #6bcdd0;
$circle-default: #6bcdd0;

$header-row-height: 43px;
$first-col-width: 12em;
// $col-min-width: 300px;
$num-cell-width: 18px;
// .table-container {
//   height: inherit;
// }

.table-container {
  position: relative;
  height: max-content;
  overflow: auto;
}
table {
  margin: 0 0 6px;
  thead {
    tr {
      th {
        border: 1px solid #dee2e6;
        text-align: center;
        vertical-align: middle;
      }
    }
  }
  tbody {
    tr {
      td {
        border: 1px solid #dee2e6;
        vertical-align: middle;
      }
      .result-nums-container {
        display: flex;
        justify-content: center;
        align-items: center;
        & > div {
          margin-right: 5px;
          &:last-child{margin-right: 0;}
        }
      }
      .lot-num {
        color: #ffffff;
        width: $num-cell-width;
        height: $num-cell-width;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 999;
      }
      .not-lot-num {
        width: $num-cell-width;
        height: $num-cell-width;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .leaksLevel {
        background-color: #9595c5 !important;
      }
      .digit-default {
        background-color: $bg-default;
        .lot-num {
          background-color: $circle-default;
        }
      }
      .digit-0 {
        background-color: $bg-orange;
        .lot-num {
          background-color: $circle-orange;
        }
      }
      .digit-1 {
        background-color: $bg-blue;
        .lot-num {
          background-color: $circle-blue;
        }
      }
      .digit-2 {
        background-color: $bg-green;
        .lot-num {
          background-color: $circle-green;
        }
      }
      .digit-3 {
        background-color: $bg-purple;
        .lot-num {
          background-color: $circle-purple;
        }
      }
      .digit-4 {
        background-color: $bg-emerald;
        .lot-num {
          background-color: $circle-emerald;
        }
      }
      .digit-5 {
        background-color: $bg-yellow;
        .lot-num {
          background-color: $circle-yellow;
        }
      }
      .digit-6 {
        background-color: $bg-red;
        .lot-num {
          background-color: $circle-red;
        }
      }
      .digit-7 {
        background-color: $bg-cyan;
        .lot-num {
          background-color: $circle-cyan;
        }
      }
      .digit-8 {
        background-color: $bg-orange;
        .lot-num {
          background-color: $circle-orange;
        }
      }
      .digit-9 {
        background-color: $bg-green;
        .lot-num {
          background-color: $circle-green;
        }
      }
    }
  }
}
@media (max-width: 575.98px) {
  .table-container {
    position: relative;
    overflow: auto;
  }
  .fixed-height{
    height: calc(100vh - 95px - 52px - 100px);
  }
  table {
    color: #4F4F4F;
    thead {
      tr{
        &:nth-child(1) {
          & > th {
            &:nth-child(1) {min-width: 6.2em;}
            &:nth-child(2) {min-width: 6.2em;}
          }
        }
        th {
          border-top: none;
        }
      }
    }
  }
}
@media (min-width: 576px) and (max-width: 767.98px) {
  .table-container {
    position: relative;
    overflow: auto;
  }
  .fixed-height{
    height: calc(100vh - 95px - 52px - 100px);
  }
  table {
    color: #4F4F4F;
    thead {
      tr{
        &:nth-child(1) {
          & > th {
            &:nth-child(1) {min-width: 6.2em;}
            &:nth-child(2) {min-width: 6.2em;}
          }
        }
        th {
          border-top: none;
        }
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  table {
    thead {
      tr:nth-child(1) {
        th:nth-child(1) {
          min-width: $first-col-width;
        }
        th:nth-child(2) {
          min-width: 180px;
        }
      }
    }
    tbody {
      tr {
        .result-nums-container {
          // gap: 5px;
          & > div {
            margin-right: 5px;
            &:last-child {margin-right: 0;}
          }
        }
        td:nth-child(2) {
          left: $first-col-width !important;
        }
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  table {
    thead {
      tr:nth-child(1) {
        th:nth-child(1) {
          min-width: $first-col-width;
        }
        th:nth-child(2) {
          min-width: 180px;
        }
      }
    }
    tbody {
      tr {
        .result-nums-container {
          // gap: 5px;
          & > div {
            margin-right: 5px;
            &:last-child {margin-right: 0;}
          }
        }
        td:nth-child(2) {
          left: $first-col-width !important;
        }
      }
    }
  }
}
@media (min-width: 1200px) {
  // .b-table-sticky-header {
  //   max-height: 600px;
  // }
  table {
    thead {
      tr:nth-child(1) {
        th:nth-child(1) {
          min-width: $first-col-width;
        }
        th:nth-child(2) {
          min-width: 180px;
          // left: $first-col-width !important;
        }
        // th:not(:nth-child(1)):not(:nth-child(2)) {
          // min-width: $col-min-width;
          // min-width: var(--col-min-width);
        // }
      }
      // tr:nth-child(2) {
        // th {
          // top: $header-row-height !important;
        // }
      // }
    }
    tbody {
      tr {
        .result-nums-container {
          // gap: 5px;
          & > div {
            margin-right: 5px;
            &:last-child {margin-right: 0;}
          }
        }
        td:nth-child(2) {
          left: $first-col-width !important;
        }
      }
    }
  }
}
</style>
